export default {
  // 方法1
  testMethod1: function () {
   
    this.$router.go(-1);
  },
  // 方法2
  testMethod2: function (val) {
    console.log('巧了，我也是测试公共方法，我是', val)
  }
}
